// Copyright (c) 2020 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { MouseEvent } from "react";
import { Column as Column_, TableOptions, useTable } from "react-table";

export type Column<T extends object> = Column_<T>;

interface TableProps<T extends object> extends TableOptions<T> {
  isDeleted?: (item: T) => boolean;
  onSelect?: (e: MouseEvent, item: T) => void;
}

export function Table<T extends object>(options: TableProps<T>) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(options);
  const { isDeleted, onSelect } = options;
  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map(column => (
          <tr {...column.getHeaderGroupProps()}>
            {column.headers.map(column => (
              <th {...column.getHeaderProps({
                style: {
                  minWidth: column.minWidth,
                },
              })}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
        <tr></tr>
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          const select =
            onSelect == null
              ? {}
              : {
                onClick: (e: MouseEvent) => onSelect(e, row.original),
              };
          const className =
            isDeleted != null && row != null && isDeleted(row.original)
              ? "deleted table-row"
              : "table-row";
          return (
            <tr {...row.getRowProps()} {...select} className={className}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
